import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

export const DescriptionText = styled.span<{ isLastItem?: boolean }>`
  height: ${({ theme }) => theme.lineHeight.one_2};

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
  text-align: left;

  max-width: 50ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  cursor: ${({ isLastItem }) => (isLastItem ? 'pointer' : 'auto')};
  :hover {
    color: ${({ isLastItem, theme }) =>
      isLastItem ? theme.colors.primary_dark : theme.colors.black_100};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fontSize.xxs};
  }

  :not(:last-child):after {
    content: '/';
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    font-family: ${({ theme }) => theme.fontFamily.regular};
    letter-spacing: normal;
    text-align: left;

    padding: 0 ${({ theme }) => theme.spacing.zero_1};

    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${({ theme }) => theme.fontSize.xxs};
    }
  }

  &:last-of-type {
    font-family: ${({ theme }) => theme.fontFamily.semiBold};
  }
`;

export const BackIcon = styled(Link)`
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing.one};

  :hover {
    svg path {
      stroke: ${({ theme }) => theme.colors.black_80};
    }
  }
`;
